import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Form from 'react-bootstrap/Form'
import { Control, FieldValues, useController } from 'react-hook-form';
import { SiteAssignmentDto } from '../dtos/SiteAssignmentsDto';
import { FormCommonProps } from '../Forms/FormCommon';

interface FormSiteAssignmentProps<FormType extends FieldValues> extends FormCommonProps<FormType> {
  control: Control<FormType>,
  sites: SiteAssignmentDto[],
}

export function FormSiteAssignment(props: FormSiteAssignmentProps<any>) {
  const { field } = useController({ name: props.name, control: props.control, rules: { ...props.options } });
  const assignedSiteIds: string[] = field.value;

  const isSiteUnavailable = (s: SiteAssignmentDto): boolean =>
    !!s.unassignableReasons && s.unassignableReasons.length > 0;

  const availableSites = props.sites.filter(site => !isSiteUnavailable(site));
  const allSelected = !!availableSites.length && availableSites.every(site => assignedSiteIds.includes(site.siteId));

  const siteChanged = (checked: boolean, siteId: string) =>
    field.onChange(checked
      ? [...assignedSiteIds, siteId]
      : assignedSiteIds.filter(id => id !== siteId));

  const selectAllChanged = (event: React.ChangeEvent<HTMLInputElement>) =>
    field.onChange(event.target.checked ? availableSites.map(site => site.siteId) : []);

  return <Form.Group className="d-flex flex-column" style={{ minHeight: 0 }}>
    <div className="list-group overflow-auto" style={{ minHeight: 0 }}>
      <Form.Check
        type="checkbox"
        label="Select All"
        checked={allSelected}
        onChange={selectAllChanged}
        disabled={availableSites.length === 0}
      />
      {props.sites.map(site => (
        <OverlayTrigger
          key={site.siteId}
          placement="bottom-start"
          popperConfig={{ modifiers: [{ name: 'arrow', options: { padding: 30 } }] }}
          overlay={isSiteUnavailable(site)
            ? <Tooltip>
              <ul className="my-0 pl-3">
                {site.unassignableReasons!.map((r, index) => <li key={index} className="text-start">{r}</li>)}
              </ul>
            </Tooltip>
            : <></>}>
          {({ ref, ...triggerHandler }) => (
            <div data-testid={site.siteId} {...triggerHandler}>
              <Form.Check
                ref={ref}
                label={site.siteName}
                id={site.siteId}
                checked={assignedSiteIds.includes(site.siteId)}
                onChange={ev => siteChanged(ev.target.checked, site.siteId)}
                disabled={isSiteUnavailable(site)}
                style={{ pointerEvents: isSiteUnavailable(site) ? 'none' : 'auto' }} />
            </div>
          )}
        </OverlayTrigger>
      ))}
    </div>
  </Form.Group>
}
